import LoadingDisplay from "../../../common/LoadingDisplay/LoadingDisplay";
import Container from "../../../common/Container";
import TestMemeContainer from "../../../common/TestMemeContainer";
import TimeDisplayComponent from "./timeDisplayComponent/index";
import ManualApproval from "../../../Applications/memeApproval";
import ChatNotifactionDisplay from "./chatNotificationDisplay";
import { useTranslation } from "react-i18next";

const SettingsDisplay = ({
    getSettings,
    updateUserSettings,
    approveOrDenyMeme,
    deletePendingMeme,
    pushPendingMeme,
    currentMeme,
    loading,
}) => {
    const { t } = useTranslation("settings");

    let content1 = <TestMemeContainer extended={true} />;

    let content2 = (
        <TimeDisplayComponent
            getSettings={getSettings}
            updateUserSettings={updateUserSettings}
        />
    );

    let content3 = (
        <ManualApproval
            getSettings={getSettings}
            updateUserSettings={updateUserSettings}
            approveOrDenyMeme={approveOrDenyMeme}
            deletePendingMeme={deletePendingMeme}
            pushPendingMeme={pushPendingMeme}
            currentMeme={currentMeme}
            applicationDisplayLocation={"settings"}
        />
    );
    let content4 = (
        <ChatNotifactionDisplay
            getSettings={getSettings}
            updateUserSettings={updateUserSettings}
        />
    );
    let placeHolder = (
        <p className="testMemeMessageText">{t("MoreSettingsCommingSoon")}</p>
    );

    let display = (
        <div className="scrollableContainer">
            <Container
                content={
                    <>
                        <Container content={content1} dynamicContainer={true} />
                        <Container content={content2} dynamicContainer={true} />
                        <Container content={content3} dynamicContainer={true} />
                        <Container content={content4} dynamicContainer={true} />
                        <Container
                            content={placeHolder}
                            dynamicContainer={true}
                        />
                    </>
                }
                dynamicContainerDiv={true}
            />
        </div>
    );

    if (loading) return <LoadingDisplay />;
    else return display;
};

export default SettingsDisplay;
